import { useState } from "react";
import Layer from "./Layer";
import Folder from "./Folder";
import LayersActions from "actions/LayersActions";
import { getLayerInputs } from "actions/GlobalActions";
import { boxShadow } from "styles/common";

type IFolderTree = {
    view: any;
    foldersTree: any;
    currentTree?: any;
    currentProject: any;
    selectedLayers: any;
    folderLevel?: number;
    folderStatus?: string;
    folderHidden?: boolean;
    setSelectedLayers: (layer: any) => void;
    toggleSelectedLayers: (layer: any) => void;
    setLayerId: (layerId: string) => void;
    toggleVisibility: (visible: boolean, layerId: string) => void;
    setTransparency: (value: number, layerId: string) => void;
    updateParent: () => void;
    addObjects: (source?: string) => void;
};

export default function FolderTree(props: IFolderTree) {
    var { view, currentProject, addObjects, updateParent, currentTree } = props;
    var foldersTree = LayersActions.foldersTree;
    if (!currentTree) {
        currentTree = foldersTree;
    }

    const [update, setUpdate] = useState(false);
    //console.log('foldersTree:', foldersTree);
    if (!currentTree) {
        return <div />;
    }
    if (currentTree[0] && currentTree[0].name === "Root") {
        currentTree = currentTree[0].children;
    }
    //console.log('FoldersTree:currentTree:', currentTree);
    const toggleFolderVisibility = (ID: string) => {
        var currentFolder: any = currentTree.find((folder: any) => folder.ID === ID);
        if (currentFolder) {
            var status = currentFolder.status;
            var level = currentFolder.level;
            var newStatus = "";
            var visible = true;
            if (status === "expand") {
                newStatus = "collapse";
                visible = false;
            } else {
                newStatus = "expand";
                visible = true;
            }
            currentFolder.status = newStatus;
            var currentLevel = level + 1;
            var maxLevel = LayersActions.findMaxLevel(foldersTree, currentFolder.ID);
            while (currentLevel <= maxLevel) {
                var nextFolders = LayersActions.findFolderByLevel(foldersTree, currentLevel);
                if (nextFolders.length > 0) {
                    nextFolders.forEach((folder: any) => {
                        if (folder.layers === currentFolder.layers) {
                            folder.visible = visible;
                            folder.status = newStatus;
                        }
                    });
                }
                currentLevel++;
            }
        }
        setUpdate(!update);
    };
    const renameFolder = (ID: string, name: string) => {
        LayersActions.renameFolder(ID, view.project, name);
    };

    return currentTree.map((item: any, index: number) => {
        if (item["view_type"] === "folder") {
            return (
                <Folder
                    key={"folder-" + item.ID}
                    ID={item.ID}
                    name={item.name}
                    childrenCount={LayersActions.getChildrenCount(item.ID)}
                    level={item.level}
                    defaultStatus={item.status}
                    disabled={item.disabled}
                    toggleFolderVisibility={toggleFolderVisibility}
                    renameFolder={renameFolder}
                    addObjects={addObjects}
                    updateParent={updateParent}
                    style={{
                        height: 24,
                        boxShadow: boxShadow,
                        display: item.visible ? "flex" : "none",
                        alignItems: "center",
                    }}
                >
                    <FolderTree {...props} currentTree={item.children} />
                </Folder>
            );
        } else {
            let type = "",
                childrenCount = 0;
            const layerFolder: any = LayersActions.findItemById(item["view_folder"]);
            const inputs = getLayerInputs(item);
            if (inputs && Array.isArray(inputs)) {
                const input: any = inputs.find((elem: any) => elem.type === "3");
                if (input) {
                    let inputId: string = inputs[input.entity].id;
                    let entityId = item["input_value_" + inputId];
                    if (currentProject[entityId] && currentProject[entityId]["mesh_count"]) {
                        childrenCount = currentProject[entityId]["mesh_count"];
                        type = "set";
                    }
                }
            }
            return (
                <Layer
                    key={"layer-" + index + "-" + item.ID}
                    {...props}
                    layer={item}
                    inputs={inputs}
                    type={type}
                    folderStatus={layerFolder ? layerFolder.status : "expand"}
                    folderLevel={layerFolder ? layerFolder.level : 0}
                    folderHidden={layerFolder ? !layerFolder.visible : false}
                    childrenCount={childrenCount ? childrenCount : 0}
                    draggable={true}
                />
            );
        }
    });
}
